import { render, staticRenderFns } from "./upload-popup.vue?vue&type=template&id=0b6cfc1a&scoped=true&"
import script from "./upload-popup.ts?vue&type=script&lang=ts&"
export * from "./upload-popup.ts?vue&type=script&lang=ts&"
import style0 from "./upload-popup.scss?vue&type=style&index=0&id=0b6cfc1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6cfc1a",
  null
  
)

export default component.exports